import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SideMenuSubpageContext } from 'src/features/onboarding/constants/Context';
import SideMenuNavButton from '../../drawer-sidemenu/SideMenuNavButton';
import { Heading } from '@innovationnorway/cl-react';

const Index = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');
  const { setPage } = useContext(SideMenuSubpageContext);

  return (
    <>
      <Heading level={2}>{tHelpAndSupport('commonQuestions.Owi')}</Heading>
      <div>
        <SideMenuNavButton onClick={() => setPage && setPage('index/commonQuestions/owi/actorCommunication')}>
          {tHelpAndSupport('commonQuestions.Interplay.CommunicationBetweenActors')}
        </SideMenuNavButton>
        <SideMenuNavButton onClick={() => setPage && setPage('index/commonQuestions/owi/referralProcess')}>
          {tHelpAndSupport('commonQuestions.Interplay.Referralprocess')}
        </SideMenuNavButton>
        <SideMenuNavButton onClick={() => setPage && setPage('index/commonQuestions/owi/howTo')}>
          {tHelpAndSupport('commonQuestions.Interplay.HowTo')}
        </SideMenuNavButton>
        <SideMenuNavButton onClick={() => setPage && setPage('index/commonQuestions/owi/invite')}>
          {tHelpAndSupport('commonQuestions.Invite')}
        </SideMenuNavButton>
        <SideMenuNavButton onClick={() => setPage && setPage('index/commonQuestions/owi/journey')}>
          {tHelpAndSupport('commonQuestions.Journey')}
        </SideMenuNavButton>
        <SideMenuNavButton onClick={() => setPage && setPage('index/commonQuestions/owi/customerFollowUp')}>
          {tHelpAndSupport('commonQuestions.CustomerFollowUp')}
        </SideMenuNavButton>
        <SideMenuNavButton onClick={() => setPage && setPage('index/commonQuestions/owi/serviceTemplates')}>
          {tHelpAndSupport('commonQuestions.ServiceTemplates.HowTo')}
        </SideMenuNavButton>
      </div>
    </>
  );
};

export default Index;
